import { ObjectMapper } from "json-object-mapper";
import { IModel } from "../IModel";
import { Model } from "../model";

export class SubordinateEmployeeModel
  extends Model
  implements IModel<SubordinateEmployeeModel> {

  id = "";
  name = "";
  profileImagePath = "";
  costCenterName = "";
  jobTitleName = "";
  isDirect = false;

  static create(input: any): SubordinateEmployeeModel {
    return ObjectMapper.deserialize<SubordinateEmployeeModel>(
      SubordinateEmployeeModel,
      input
    );
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
